import { render, staticRenderFns } from "./tabs.vue?vue&type=template&id=1d6c8961&scoped=true"
import script from "./tabs.vue?vue&type=script&lang=js"
export * from "./tabs.vue?vue&type=script&lang=js"
import style0 from "./tabs.vue?vue&type=style&index=0&id=1d6c8961&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6c8961",
  null
  
)

export default component.exports